import { render, staticRenderFns } from "./purchase_details.vue?vue&type=template&id=28ac2be9"
import script from "./purchase_details.vue?vue&type=script&lang=js"
export * from "./purchase_details.vue?vue&type=script&lang=js"
import style0 from "./purchase_details.vue?vue&type=style&index=0&id=28ac2be9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports